<script setup lang="ts">
// import bg1 from "@/assets/images/backgroundServices/carousel/carosel1.png";
// import bg2 from "@/assets/images/backgroundServices/carousel/carosel1.png";
// import bg3 from "@/assets/images/backgroundServices/carousel/carosel1.png";
defineProps<{
	images: string[];
}>();

// const sliderWrapper = ref();

// function navigate(direction: string) {
// 	let el = sliderWrapper.value;
// 	const step = document.querySelector<HTMLDivElement>(".service-page");
// 	let itemWidth = step?.offsetWidth ?? 500;

// 	if (direction === "right") {
// 		el.scrollLeft += itemWidth; // itemWidth * (itemsShown - 1);
// 	} else {
// 		console.log(itemWidth);
// 		el.scrollLeft -= itemWidth; // itemWidth * (itemsShown - 1);
// 	}
// }
</script>
<template>
	<div class="slider-wrapper">
		<slider6 :images="images" />
		<!-- <slider6backup :images="images" /> -->
	</div>
</template>

<style lang="scss" scoped>
.slider-wrapper {
	// border-bottom-left-radius: 32px;
	// border-bottom-right-radius: 32px;
	padding-bottom: 20px;
	padding-top: 20px;
	background: #0d1015;
	// background-color: rgb(2, 62, 62);
	overflow: hidden;

	.slider-content {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		overflow: auto;
		scroll-behavior: smooth;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none;
	}
	.slider-content::-webkit-scrollbar {
		display: none;
	}
}

@media screen and (width <= 768px) {
	.slider-wrapper {
		position: relative;
	}
}
</style>
